import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { Observable, lastValueFrom } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { Location } from '@angular/common';
import { WoundService } from 'src/app/services/wound.service';
import { MatTableDataSource } from '@angular/material/table';
import { HttpResponse } from '@angular/common/http';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AuthService } from 'src/app/services/auth.service';
import { UserService } from 'src/app/services/Modules/user.service';
import * as global from 'src/app/includes/global';
import { TranscriptionCreateService } from '../../transcription-create/transcription-create.service';

@Component({
  selector: 'app-bims-phq9-patient-report',
  templateUrl: './bims-phq9-patient-report.component.html',
  styleUrls: ['./bims-phq9-patient-report.component.css']
})

export class BimsPhq9PatientReportComponent implements OnInit {

  currentDate = moment(new Date());
  minDate = moment(new Date()).subtract(6, 'days');
  loaderId = 'app-bims-phq9-report';
  filter: any = {
    is_active: "true",
    is_trashed: { $ne: "true" },
    company_id: null,
    date_of_service: {
      startDate: moment().subtract(6, 'days'),
      endDate: moment()
    },
  };
  providerId: null;
  facilityId: null;
  preDateRanges: any = {
    'Today': [moment(), moment()],
    'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
    'Last 1 Week': [moment().subtract(6, 'days'), moment()],
    'Last 2 Week': [moment().subtract(13, 'days'), moment()],
    'Last 3 Week': [moment().subtract(20, 'days'), moment()],
    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
    'This Month': [moment().startOf('month'), moment().endOf('month')],
    'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
  };
  filteredFacilities: Observable<string[]>;
  displayedColumns: string[] = ['Patient_Name', 'DOS', 'Provider', 'Facility', 'Payor', 'BIMS_Score', 'PHQ9_Score'];
  facilityControl = new FormControl();
  facilities: Array<any> = [];
  providerControl = new FormControl();
  providers: Array<any> = [];
  filteredProviders: Observable<string[]>;
  bims_phq9_report: any = [];
  dataSource: any = new MatTableDataSource([]);
  pagination = {
    pageNo: 1,
    hasNextPage: false,
    hasPrevPage: false,
    totalRecords: 0,
    PAGE_LIMIT: 50,
    skip: 0
  };
  companySide: boolean = false;
  currentUser: any;
  user_dashboard: Boolean = false;
  nursingSide: boolean;
  provideModel: string = ''; // Example initialization
  showPccLogo: boolean = false; // Example initialization
  facilityMOdel: string = ''; // Example initialization
  
  constructor(
    private _toastr: ToastrService,
    private _route: ActivatedRoute,
    private _location: Location,
    private _wound: WoundService,
    private loader: NgxUiLoaderService,
    private _authService: AuthService,
    private _userService: UserService,
    private _transcriptionCreateService: TranscriptionCreateService,
  ) {
    this.currentUser = this._authService.currentUser;
    this.filter.company_id = this._route.parent.snapshot.params.id;
    this._route.queryParams.subscribe((params: any) => {
    });
    if (this._route.parent.snapshot.params.id) {
      this.companySide = true;
    } else {
      this.filter.company_id = this.currentUser.company_id;
    }
    if (window.location.pathname.includes('dashboard')) {
      this.user_dashboard = true;
    }
    if (window.location.pathname.includes('nursing')) {
      this.nursingSide = true;
    }
  }

  async ngOnInit() {
    this.loader.startLoader(this.loaderId);
    await this.getProviderList();
    this.selectDefaultProvider();
    await this.initFacilities(this.providerId, null, this.filter.company_id);
    this.initBimsPhq9Report();
    this.filteredFacilities = this.facilityControl.valueChanges.pipe(
      startWith(''),
      map((value: any) => this.filterFacilities(value)));
    this.loader.stopLoader(this.loaderId);
  }
  private filterFacilities(value: string): string[] {
    if (value) {
      const filterValue = value.toLowerCase();
      return this.facilities.filter(option => option.title.toLowerCase().indexOf(filterValue) > -1);
    }
    else {
      return this.facilities;
    }
  }
  selectDefaultFacility() {
    if (this.facilities.length > 0) {
      this.facilityId = this.facilities[0]._id;
    }
    this.facilityControl.setValue(this.facilities[0].title);
  }

  private filterProvider(value: string): string[] {
    if (value && this.providers.length > 0) {
      const filterValue = value.toLowerCase();
      return this.providers.filter(option => option.full_name.toLowerCase().match(filterValue));
    }
    else {
      return this.providers;
    }
  }

  getProvidersByFacility(facilityId) {
    return new Promise<void>((resolve, reject) => {
      this._userService.getUsersByFacility(facilityId).subscribe({
        next: (response: any) => {
          if (response.status === 200) {
            this.providers = response.data;
            this.providers.unshift({ _id: 'all', full_name: 'All' });
            this.selectDefaultProvider();
            this.showProviderDropdown();
            resolve();
          }
        }, error: error => {
          reject('error => ' + error.toString());
        }
      });
    });
  }

  getProviderList() {
    const filter: any = {
      company_id: this.filter.company_id,
      user_type: global.USER_TYPE.DOCTOR
    };
    const projection = {
      first_name: 1,
      last_name: 1,
      title: 1,
      full_name: 1
    };
    return new Promise<void>((resolve, reject) => {
      this._userService.getUsers(filter, projection).subscribe({
        next: (response: any) => {
          if (response.status === 200) {
            this.providers = response.data;
            this.providers.unshift({ _id: 'all', full_name: 'All' });
            this.selectDefaultProvider();
            this.showProviderDropdown();
            resolve();
          }
        }, error: error => {
          reject('error => ' + error.toString());
        }
      });
    });

  }

  onSelectProvider(event) {
    if (event === 'all') {
      this.providerId = null;
    }
    else {
      this.providerId = event;
    }
    this.facilityId = null;
    this.initFacilities(this.providerId, null, this.filter.company_id);
  }
  showProviderDropdown(): void {
    this.filteredProviders = this.providerControl.valueChanges.pipe(
      startWith(''),
      map((value: any) => this.filterProvider(value)));
  }

  selectDefaultProvider() {
    if (this.providers.length > 0) {
      this.providerId = null;
      this.providerControl.setValue(this.providers[0].full_name);
    }
  }

  async initBimsPhq9Report() {
    this.loader.startLoader(this.loaderId);

    if (this.providerId != null)
      this.filter['doctor_id_ref'] = this.providerId;
    if (this.facilityId != null)
      this.filter['facility_id_ref'] = this.facilityId;

    const response: any = await lastValueFrom(this._wound.getBimsPhq9Report(this.filter));
    if (response.status == 200) {
      this.bims_phq9_report = response.data;
      this.pagination.totalRecords = response.data.length;
      this.handlePagination();
      this.dataSource.data = this.bims_phq9_report;
      this.loader.stopLoader(this.loaderId);
    }
    else {
      this.loader.stopLoader(this.loaderId);

    }
    delete this.filter.doctor_id_ref;
    delete this.filter.facility_id_ref;
  }
  handlePagination() {
    this.pagination.skip = (this.pagination.pageNo - 1) * this.pagination.PAGE_LIMIT;
    if (this.pagination.skip + this.bims_phq9_report.length < this.pagination.totalRecords) {
      this.pagination.hasNextPage = true;
    }
    else {
      this.pagination.hasNextPage = false;
    }
    if (this.pagination.skip > 0) {
      this.pagination.hasPrevPage = true;
    }
    else {
      this.pagination.hasPrevPage = false;
    }
  }

  async initFacilities(provider = null, source = null, company_id = null) {
    let response: any = {};
    if (this.providerId) {
      response = await this._transcriptionCreateService.getFacilities(provider, source, company_id).toPromise();
    }
    if (response.status === 200) {
      this.facilities = response.data.array;
      this.filteredFacilities = this.facilityControl.valueChanges.pipe(
        startWith(''),
        map((value: any) => this.filterFacilities(value))
      );
    }
  }
  onSelectFacility($event, facility) {
    if ($event.isUserInput) {
      this.facilityId = facility._id;
    }
  }
  changeDateOfService(event) {
    if (event.startDate && event.endDate) {
      this.filter.date_of_service = {
        startDate: null,
        endDate: null
      };
      const startDate = moment(event.startDate);
      const endDate = moment(event.endDate);
      const noOfDays = endDate.diff(startDate, 'days');
      // if (noOfDays > 6) {
      //   this.filter.date_of_service = {};
      //   this.filter.date_of_service.startDate = moment(event.startDate);
      //   this.filter.date_of_service.endDate = moment(this.filter.date_of_service.startDate).add(6, "days").endOf('day');
      //   this._toastr.error('Can not select more than 7 days', 'Date Error');
      // }
      // else {
      this.filter.date_of_service.startDate = event.startDate;
      this.filter.date_of_service.endDate = event.endDate;
      // }
    }
  }

  goBack() {
    this._location.back();
  }
  handleApplyFilter() {
    this.pagination = {
      pageNo: 1,
      hasNextPage: false,
      hasPrevPage: false,
      totalRecords: 0,
      PAGE_LIMIT: 50,
      skip: 0
    };
    this.initBimsPhq9Report();
  }

  resetFilter() {
    delete this.filter.date_of_service;
    const defaultDate = {
      startDate: moment().subtract(6, 'days'),
      endDate: moment()
    };
    this.filter.date_of_service = defaultDate;
    this.providerControl.setValue('');
    this.facilityControl.setValue('');
    this.initBimsPhq9Report();
  }
  exportBimsPhq9ReportAsXLSX() {
    if (this.providerId != null)
      this.filter['doctor_id_ref'] = this.providerId;
    if (this.facilityId != null)
      this.filter['facility_id_ref'] = this.facilityId;

    const infoToastr = this._toastr.info('Exporting as XLSX...', 'Please wait', { disableTimeOut: true });
    this._wound.exportBimsPhq9ReportAsXLSX(this.filter).subscribe((response: any) => {

      if (response instanceof HttpResponse) {
        const url = window.URL.createObjectURL(response.body);
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = url;
        a.download = `BIMS PHQ9 Report`;
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove(); // remove the element
        this._toastr.clear(infoToastr.toastId);
      }
    });
    delete this.filter.doctor_id_ref;
    delete this.filter.facility_id_ref;
  }
  goToPreviousPage() {
    this.pagination.pageNo--;
    this.initBimsPhq9Report();
  }
  goToNextPage() {
    this.pagination.pageNo++;
    this.initBimsPhq9Report();
  }
}

